export const SUCCESS  = 200
export const ERROR  = 999
export const GOOGLE_API  = '6LeTwbQgAAAAANiCbIiNZmEZGB2kXsdBzRwi0FsQ'
export const GOOGLE_API_SECRET  = '6LeTwbQgAAAAAGVQM2uW21MHwGkal3CKiL-7YPVQ'
export const GOOGLE_MAP_API = 'AIzaSyDB1VWcFVWZExdauD9_CnJBCAWPv05QeDo'
// AIzaSyAvEaJtEJVrovB5tQU7QQ6OKLr5L2NsRG0
// AIzaSyBKYWzsediFkY2BvgEYJJd6CiMc3m_Pt7o
//AIzaSyDhlc0Eu_bi-c18fcstMaUnL83CF-6Xs70

/** Facebook Login App ID — lấy từ Meta Developers */
export const FACEBOOK_APP_ID =
  process.env.VUE_APP_FACEBOOK_APP_ID || ""
export const FACEBOOK_API_VERSION =
  process.env.VUE_APP_FACEBOOK_API_VERSION || "v21.0"

export const SLIDE_BAR_URL  = []
export const FILE_EXCEL_TYPE = ["csv","xlsx","xlm","xlsb"]
export const ICON_EXCEL ="https://img.icons8.com/color/344/microsoft-excel-2019--v1.png"